import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Pricing.css';

const Pricing: React.FC = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/contact');
    window.scrollTo(0, 0);
  };

  return (
    <section className="pricing-section" style={{ padding: '0', background: 'transparent' }}>
      <div className="pricing-header animate-fade-up">
        <p className="pricing-overview">
          We understand how critical it is for you to have an expert at the other end of the phone. We're flexible in our approach, and are your business partners to ensure you're achieving your goals whilst offering services that are cost effective. We offer fixed pricing packages, so there will be no surprises at the end of the year!
        </p>
        <p className="pricing-sub-overview">
          Our fixed pricing packages are value-based. We believe on fully supporting you along your journey to business growth.
        </p>
      </div>

      <div className="pricing-grid">
        {/* Maintenance */}
        <div className="pricing-card animate-fade-up delay-100">
          <h3>Maintenance</h3>
          <div className="price">$165 + GST <span className="period">per month</span></div>
          <p className="description">Our Maintenance Business Package is for small businesses that require assistance with managing compliance requirements with Inland Revenue and accessing accounting advice from our specialists.</p>
          <ul className="features-list">
            <li>Annual Financial Statements & Tax Returns</li>
            <li>GST Returns</li>
            <li>Tax and Business Advice</li>
            <li>Unlimited Email Support</li>
          </ul>
          <p className="note">*Subscribe to xero partner version start from $6.5 per month up to $28 per month</p>
          <button onClick={handleContactClick} className="pricing-btn">Get started</button>
        </div>

        {/* Growth */}
        <div className="pricing-card popular animate-fade-up delay-200">
          <div className="popular-tag">Most Popular</div>
          <h3>Growth</h3>
          <div className="price">$350 + GST <span className="period">per month</span></div>
          <p className="description">Our Growth Business package is popular among small and medium businesses that are in their growth stage. This package offers full accounting support and compliance with Inland Revenue along with ensuring that you are focussing on what you do best, and that is running the business while we support your growth.</p>
          <ul className="features-list">
            <li>Annual Financial Statements and Tax Returns</li>
            <li>GST Returns</li>
            <li>Tax and Business Advice</li>
            <li>Quarterly Management reports</li>
            <li>Tax Planning and Business Review</li>
            <li>ACC Support</li>
            <li>Unlimited Email Support</li>
          </ul>
          <p className="note">*Receive 10% off discount on Xero business version subscription</p>
          <button onClick={handleContactClick} className="pricing-btn primary">Get started</button>
        </div>

        {/* POA */}
        <div className="pricing-card animate-fade-up delay-300">
          <h3>POA</h3>
          <div className="price">Custom</div>
          <p className="description">Our top tier package is custom built taking into considerations your specific requirements. This package covers all compliance requirements and ensures you're working with a business partner, and not just an accountant.</p>
          <ul className="features-list">
            <li>Annual Financial Statements & Tax Returns</li>
            <li>GST Returns</li>
            <li>Tax and Business Advice</li>
            <li>Management reports</li>
            <li>Tax Planning and Business Review</li>
            <li>Annual Insurance Review</li>
            <li>Support with Implementing Systems and Processes</li>
            <li>Accounts Receivables Management</li>
            <li>Accounts Payables Management</li>
            <li>Bookkeeping</li>
            <li>Payroll</li>
            <li>ACC Management</li>
            <li>Unlimited Email Support</li>
          </ul>
          <p className="note">*Receive 10% off discount on Xero business version subscription</p>
          <button onClick={handleContactClick} className="pricing-btn">Get started</button>
        </div>

        {/* Rental Property Accounting */}
        <div className="pricing-card animate-fade-up delay-400">
          <h3>Rental Property Accounting</h3>
          <div className="price">$400 + GST <span className="period">per year</span></div>
          <p className="description">Our rental property accounting services are offered at a fixed fee, so you know exactly what you're paying from day one - no surprises!</p>
          <ul className="features-list">
            <li>Individual returns</li>
            <li>Annual income statement</li>
            <li>Tax advice and assessments</li>
            <li>Unlimited Support</li>
          </ul>
          <button onClick={handleContactClick} className="pricing-btn">Get started</button>
        </div>

        {/* Bookkeeping & Payroll services */}
        <div className="pricing-card animate-fade-up delay-500">
          <h3>Bookkeeping & Payroll services</h3>
          <div className="price">$100 + GST <span className="period">per month</span></div>
          <p className="description">If your paperwork and bookkeeping is keeping you up at night, we have a special package for you.</p>
          <ul className="features-list">
            <li>Debtors</li>
            <li>Creditors</li>
            <li>Bank Reconciliation</li>
            <li>GST</li>
            <li>PAYE</li>
            <li>Payroll</li>
            <li>Custom Package for your needs</li>
          </ul>
          <button onClick={handleContactClick} className="pricing-btn">Get started</button>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
